/* eslint-disable no-param-reassign */
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { images } from '../../appCore';
import { actions } from '../../redux';
import { setCanvasDrawingMode, setDrawingToolOpen, setDrawingValues } from '../../redux/board/reducer';
import { canvasSelector } from '../../redux/canvas/reducer';
import { DEFAULT_BRUSH, eventBus, MAIN_MENU, MENU_LEFT } from '../../utils';
import { KEYS_CODE } from '../../utils/keysCode';
import ElementsList from '../ElementsList';
import HandleDrawingTools from '../HandleDrawingTools';
import MenuItem from '../MenuItem';
import SystemComponents from '../SystemComponent';
import './styles.scss';

const ManageArea = () => {
  const dispatch = useDispatch();
  const [key, setKey] = useState(MAIN_MENU.elements.key);
  const { isDrawingToolOpen } = useSelector((state) => state.board);
  const { systemList, diagramList, iconList, addComponentLoading } = useSelector(canvasSelector);

  const keyCodeEvents = (e) => {
    if ((e.ctrlKey || e.metaKey) && !e.shiftKey) {
      if (e.keyCode === KEYS_CODE.K) {
        eventBus.emit('focus-search-element');
        e.stopPropagation();
        e.preventDefault();
      }
    }
  };
  const mockyOnHand = () => {
    setKey(MAIN_MENU.elements.key);
  };
  const onOpenDrawingTool = () => {
    dispatch(setCanvasDrawingMode(!isDrawingToolOpen));
    dispatch(setDrawingToolOpen(!isDrawingToolOpen));
    if (!isDrawingToolOpen) {
      dispatch(setDrawingValues(DEFAULT_BRUSH));
    }
  };

  useEffect(() => {
    if (key === MENU_LEFT.ELEMENS && systemList.length === 0 && !addComponentLoading) dispatch(actions.fetchSystems());
    if (key === MENU_LEFT.DIAGRAMS && diagramList.length === 0 && !addComponentLoading)
      dispatch(actions.fetchDiagrams());
    if (key === MENU_LEFT.ICONS && iconList.length === 0 && !addComponentLoading) dispatch(actions.fetchIcons());
  }, [key, addComponentLoading]);

  useEffect(() => {
    document.addEventListener('keydown', keyCodeEvents);
    eventBus.on('on-free-drawing', onOpenDrawingTool);
    eventBus.on('mocky-on-hand', mockyOnHand);
    return () => {
      eventBus.off('on-free-drawing', onOpenDrawingTool);
      eventBus.on('mocky-on-hand', mockyOnHand);
      document.removeEventListener('keydown', keyCodeEvents);
    };
  }, []);

  return (
    <div className={classnames('mo__main-menu', 'show')}>
      <>
        <div className="main-nav">
          <div>
            <img className="logo" src={images.MOCKY_ICON} alt="Mocky App" />
          </div>
          {Object.values(MAIN_MENU).map((item, index) => (
            <div
              key={index}
              onClick={() => setKey(item.key)}
              // className={isMenuDisable(item.key) ? 'disabled' : ''}
            >
              <MenuItem item={item} index={index} menuChosen={key} />
            </div>
          ))}
        </div>
        <div className="tab-content">
          <div className="project-content">
            <span className="project-icon">
              <FontAwesomeIcon icon={faLayerGroup} color="rgb(24, 144, 255)" />
            </span>
            <div className="project-info">
              <span className="project-name">Mocky</span>
            </div>
          </div>
          <HandleDrawingTools />
          {key === MENU_LEFT.ELEMENS && <ElementsList />}
          {key === MENU_LEFT.DIAGRAMS && <SystemComponents componentObj={MAIN_MENU.diagrams} />}
          {key === MENU_LEFT.ICONS && <SystemComponents componentObj={MAIN_MENU.icons} />}
        </div>
      </>
    </div>
  );
};

export default ManageArea;
